// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Link from "@insite/mobius/Link";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { linkStyles } from "@store/Themes/common/mixins/link";
import React, { FC } from "react";
import { css } from "styled-components";

export interface DocumentsWrapperErrorProps {
    message?: string;
    emailTo?: string;
}

export interface DownloadDocumentErrorStyles {
    emailLink?: LinkPresentationProps;
}

export const downloadDocumentErrorStyles: DownloadDocumentErrorStyles = {
    emailLink: {
        css: css`
            ${linkStyles("text.link", null, false, true)}
            display: inline;
        `,
    },
};

const styles = downloadDocumentErrorStyles;

const DocumentsWrapperError: FC<DocumentsWrapperErrorProps> = ({ message, emailTo }) => {
    if (emailTo) {
        return (
            <>
                {translate(
                    "Document is currently unavailable, but our team is on it. Please check back in 1 business day or contact",
                )}{" "}
                <Link {...styles.emailLink} href={`mailto:${emailTo}`}>
                    {translate("Greif Customer Service")}
                </Link>
            </>
        );
    }

    return <>{message || translate("Document is not available, please get in touch with Greif Customer Service")}</>;
};

export default DocumentsWrapperError;
